// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ed3964bf","732":"9d8d4641","977":"9da9f809"}[chunkId] + ".chunk.js";
};